import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from '../hooks/useForm';
import { usePasswordReset } from '../hooks/usePasswordReset';
import '../auth.css';
import Header from '../header';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const { requestPasswordReset, loading, error } = usePasswordReset();
  const navigate = useNavigate();

  const { values, handleChange, handleSubmit, resetForm } = useForm({
    initialValues: {
      email: '',
    },
    onSubmit: async formData => {
      const result = await requestPasswordReset(formData.email);
      if (result) {
        resetForm();
        // Navigate to check email page with the user's email
        navigate(
          `/check-email?email=${encodeURIComponent(formData.email)}&type=password-reset`
        );
      }
    },
  });

  return (
    <div className=" min-vh-100 d-flex flex-column">
      <Header />
      <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-white">
        <div className="col-md-4 form_card">
          <h2 className="mb-4 text-center">{t('forgot_password.title')}</h2>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">{t('forgot_password.email')}</label>
              <input
                type="email"
                className="form-control custom-input"
                placeholder={t('forgot_password.email_placeholder')}
                name="email"
                value={values.email}
                onChange={handleChange}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-custom w-100"
              disabled={loading}
            >
              {loading ? t('forgot_password.submitting') : t('forgot_password.submit')}
            </button>
          </form>
          <div className="text-center mt-3">
            <Link to="/" className="text-href">
              {t('forgot_password.back_login')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
